<template>
    <modal
        name="add-to-watchlist-modal"
        class="add-to-watchlist-modal"
        :adaptive="true"
        :width="356"
        :minHeight="488"
        @before-close="beforeClose"
        ref="add-to-watchlist-modal"
        @opened="onOpened"
        tabindex="0"
    >
        <div class="add-to-watchlist-modal__modal-container">
            <div class="add-to-watchlist-modal__add-new-watchlist">
                <TotemButton
                    color="secondary"
                    @click="showNewWatchlistModal"
                    @keyup.enter="showNewWatchlistModal"
                    icon="plus"
                    size="small"
                >
                    {{ $t("TotemAddToFavourite.add_to_new_watchlist") }}
                </TotemButton>
            </div>
            <TotemScrollbar class="add-to-watchlist-modal__scrollbar" v-if="watchlists.length > 0">
                <ul class="add-to-watchlist-modal__menu">
                    <li
                        class="add-to-watchlist-modal__menu-item"
                        v-for="(item, index) in manageableWatchLists"
                        @click.stop.prevent="onClickInWatchList(item.collection, item.id)"
                        @keyup.enter="onClickInWatchList(item.collection, item.id)"
                        tabindex="0"
                        :key="'favourite'+index"
                    >
                        {{ item.title }}
                        <div v-if="isInWatchList(item.collection)" class="add-to-watchlist-modal__menu-in-watchlist">
                            <span v-if="item.isShared" class="icon-users"></span>
                            <span v-else class="icon-bookmark-selected"></span>
                        </div>
                        <div v-else class="add-to-watchlist-modal__menu-in-watchlist">
                            <span class="icon-bookmark-unselected"></span>
                        </div>
                    </li>
                </ul>
            </TotemScrollbar>
            <div class="add-to-watchlist-modal__go-to-watchlists">
                <TotemButton
                    color="secondary"
                    @click="goToStudyPlans"
                    iconPosition="right"
                    icon="arrow-right"
                    size="small"
                >
                    {{ $t('TotemAddToFavourite.go_to_study_plan') }}
                </TotemButton>
            </div>
        </div>
    </modal>
</template>

<script>
    import { mapGetters } from 'vuex'
    import watchlistHelper from 'components/shared/global-courses-items/helper/watchlist-helper'

    export default {
        name: 'totem-add-to-watchlist-modal',
        mixins: [ watchlistHelper ],
        computed: {
            ...mapGetters({
                elementId: 'Watchlists/getCurrentMenuOpened',
                type: 'Watchlists/getType'
            }),
            manageableWatchLists () {
                return this.watchlists.filter(watchlist => (!watchlist.isReadonly && !watchlist.isHidden))
            }
        },
        methods: {
            goToStudyPlans () {
                this.$router.push({ name: 'user-watchlist' })
                this.$modal.hide('add-to-watchlist-modal')
            },
            onClickInWatchList (list, id) {
                if (this.isInWatchList(list)) {
                    this.removeFromWatchlist(id)
                } else {
                    this.addToWatchlist(id)
                }
            },
            isInWatchList (list) {
                return list.find(id => +id === +this.elementId)
            },
            async beforeClose () {
                await this.$store.dispatch('Watchlists/closeMenu')
                await this.$store.dispatch('Watchlists/setType', null)
            },
            onOpened () {
                this.$refs['add-to-watchlist-modal'].$el.focus()
            }
        }
    }
</script>

<style lang="scss">

    .add-to-watchlist-modal {
        height: 100%;
        display: flex;
        flex-direction: column;
        
        &__menu {
            width: 100%;
            background-color: $white;
            color: $black;
            cursor: auto !important;
            height: 340px;
    
            &-item {
                font-size: 1.6rem;
                padding: 4px 4px;
                margin: 16px 0 0;
                cursor: pointer;
                display: flex;
                justify-content: space-between;
                align-items: center;

                &:hover {
                    background-color: $bright_gray;
                }
            }

            &-item-add,
            &-item-studyplans {
                font-size: 2rem;
                padding: 12px 20px;
                cursor: pointer;
                display: flex;
                gap: 5px;
                justify-content: flex-start;

                & > button {
                    padding: 3px 15px;
                }
            }
        }

        &__menu-in-watchlist {
            margin-left: 20px;
            display: block;
            white-space: nowrap;

            .icon-bookmark-unselected,
            .icon-bookmark-selected,
            .icon-users {
                font-size: 2rem !important;
                color: $lavender;
            }
        }

        &___add-new-watchlist {
            display: flex;
        }

        &__go-to-watchlists {
            display: flex;
            margin: 15px 0px 0px;
        }

        &__scrollbar {
            flex-grow: 1;
            border: 1px solid $white;
            background: $white;
            border-radius: 6px;

            &.-empty {
                height: 154px;
            }
        }

    }

</style>
